import { render, staticRenderFns } from "./satisfaction.vue?vue&type=template&id=46395634&"
import script from "./satisfaction.vue?vue&type=script&lang=ts&"
export * from "./satisfaction.vue?vue&type=script&lang=ts&"
import style0 from "./satisfaction.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports